import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { ChatAndMeetModel } from "model/screensModels/ChatAndMeetModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { AuthService } from "services/auth/AuthService";

export class ChatAndMeetService {

  // Get Contact Person List 
  static getContactPersonList = async () => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET + RouteType.CONTACTPERSON_LIST;
    const response = AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
    return response;
  };

  // Save Chat And Meet
  static addChatAndMeet = async (requestBody: ChatAndMeetModel) => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET + RouteType.STORE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  // Get Chat And Meet Data
  static getChatAndMeetData = async (requestData) => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
    return response;
  };

  //get total unread message
  static getTotalUnreadMessage = async () => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET_COUNT;
    const response = AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
    return response;
  };

  //mark all message of selected user is read
  static markAsReadMessage = async (requestData: ChatAndMeetModel | RequestModel) => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET + RouteType.MARK_AS_READ;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
    return response;
  };


//mark all message of selected user is read
  static markAsActiveUser = async (requestData: ChatAndMeetModel) => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET + RouteType.MARK_AS_ACTIVE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
    return response;
  };


  //mark all message of selected user is read
  static markAsDeactiveUser = async (requestData: ChatAndMeetModel) => {
    const url = RouteType.ADMIN + RouteType.CHAT_MEET + RouteType.MARK_AS_DEACTIVE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
    return response;
  };

  
}